import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'bw-hardship-initial-card',
    imports: [CommonModule, BrightsideUiModule],
    templateUrl: './hardship-initial-card.component.html',
    styleUrl: './hardship-initial-card.component.css'
})
export class HardshipInitialCardComponent {
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateSvc.instant('HARDSHIP_PROGRAM_INITIAL_LABEL'),
      title: this._translateSvc.instant('HARDSHIP_PROGRAM_INITIAL_TITLE'),
      labelIcon: '',
      cardStyle: 'small',
      image: './assets/hh-init-card.png',
      backgroundSize: 'cover',
      marginBottom: 'small'
    }
  }

  navigate() {
    this._router.navigate(['hardship/intro']);
  }
}
